// extracted by mini-css-extract-plugin
module.exports = {"PhonePage":"PhonePage_PhonePage__1kS43","main":"PhonePage_main__3WFZK"};